<template>
  <div>
  
    <div class="assembly-counter">
      <span class="counter-value">{{ proverkaSborki.mass.filter(x => x == true).length }}</span>
      <span class="counter-separator">/</span>
      <span class="counter-total">{{ d.items.length }}</span>
    </div>

 
    <Suspense>
      <div class="scanner-wrapper">
        <scanner @barcode="getProductBarcode" :format="'ean_13'" style="padding-top: 0px;"/>
      </div>
    </Suspense>

    <div class="products-list">
      <div 
        class="product-item" 
        v-for="(one, index) of d.items" 
        :key="one._id" 
        :class="{ completed: proverkaSborki.mass[index] }"
      >
    
        <transition name="slimeright">
          <div v-if="proverkaSborki.mass[index]" class="completed-badge">✓</div>
        </transition>

        <img 
          :src="`https://api.ultimatum.store/image/${one.productid.images[0]}?quality=100&width=160&format=${getImageFormat(one.productid.images[0])}`" 
          :alt="one.name"
          class="product-image"
        >

        <div class="product-details">
          <p class="product-name">{{ one.name }}</p>
          <p class="product-sku">Артикул: {{ viewArtikul(one) }}</p>
         
          <div class="sborkaviewcount">
          <div class="quantity-input">
            <span class="input-label">Собрано:</span>
            <input 
              type="number" 
              v-model="one.quan" 
              class="input-field"
              min="0"
              :max="one.quantity"
            >
          </div>
          <div class="palka">/</div>
          <div class="nuzno">{{ one.quantity }}</div>
         
          </div>
        </div>

   
        <div class="marking-block" v-if="one.marking && !d.pereezd">
          <div class="marking-status">
            <span class="status-label">Честный знак:</span>
            <span class="status-value" :class="{ 'not-scanned': one.marking_code == null }">
              {{ one.marking_code == null ? 'Не отсканирован' : one.marking_code_decode.substring(0, 31) }}
            </span>
          </div>
          <button 
            class="marking-btn" 
            @click="viewScaner = { view: true, id: one._id }"
          >
            {{ one.marking_code == null ? 'Отсканировать' : 'Изменить' }}
          </button>
        </div>
      </div>
    </div>


    <transition name="slimetop">
      <div class="scanner-modal" v-if="viewScaner.view">
        <div class="scanner-header">
          <button class="close-btn" @click="viewScaner = { view: false, id: null }">
            ✕ Закрыть
          </button>
        </div>
        <Suspense>
          <scanner :format="'data_matrix'" @barcode="getDataMatrix" />
        </Suspense>
      </div>
    </transition>


    <transition name="slimetop">
      <div class="result-modal" v-if="getZnak.view">
        <div class="result-content">
          <div class="result-info">
            <span class="loader" v-if="getZnak.loading"></span>
            <p class="success" v-if="!getZnak.loading && getZnak.good">✓ Честный знак одобрен</p>
            <p class="error" v-if="!getZnak.loading && !getZnak.good">✗ Ошибка одобрения</p>
            <p class="result-comment">{{ getZnak.comment }}</p>
          </div>
          <button class="result-btn" @click="getZnak.view = false">Закрыть</button>
        </div>
      </div>
    </transition>


    <transition name="slimetop">
      <button 
        class="big_button big_button_black goodsborka" 
        v-if="proverkaSborki.status" 
        @click="goodSborka()"
        style="margin-top: 20px;"
      >
        Заказ собран
      </button>
    </transition>
  </div>
</template>

<script setup>
import scanner from '@/components/general/scanner.vue'
import { notSet, setSuc, loading, noloading, updateFunction,getImageFormat } from '@/controlles/general'
import axios from '@/utils/axios'
import { ref, onMounted, computed } from 'vue'

const { d } = defineProps(['d'])
const viewScaner = ref({
  view: false,
  id: null
})



const emit = defineEmits(['close'])

const getZnak = ref({
  view: false,
  comment: '',
  loading: true,
  good: false
})

const goodSborka = async () => {
  try {
    const complectProduct = []
    for (const one of d.items) {
      complectProduct.push({
        _id: one._id,
        marking: one.marking,
        marking_code: one.marking_code,
        marking_code_decode: one.marking_code_decode,
        marking_uuid: one.marking_uuid
      })
    }
    await axios.post('https://api.ultimatum.store/warehouse/completedorder', {
      id: d._id,
      items: complectProduct
    })
    if (['osnovnoi'].includes(d.warehouse)) {
      let dell = null
      if (d.delivery.length > 0) {
        if (d.delivery[0]._id) {
          dell = d.delivery[0]._id || d.delivery[0]
        } else {
          dell = d.delivery[0]
        }
      }
      await axios.get(`https://api.ultimatum.store/printlabel/arm?id=${dell}&service=${d.channel}&order=${d._id}`)
    }
    emit('close')
    updateFunction('collect')
  } catch (e) {
    console.log(e)
    notSet('Ошибка изменения заказа, попробуйте еще раз')
  }
}

const viewArtikul = (one) => {
  if (one.specification !== null) {
    const artikul = one.productid.specifications.find(x => x._id == one.specification)
    return artikul.artikul
  }
  return one.productid.artikul
}

const proverkaSborki = computed(() => {
  const mass = []
  for (const one of d.items) {
    if (one.quantity == one.quan) {
      if (one.marking && !d.pereezd) {
        if (one.marking_code == null) {
          mass.push(false)
        } else {
          mass.push(true)
        }
      } else {
        mass.push(true)
      }
    } else {
      mass.push(false)
    }
  }
  return {
    status: mass.every(element => element === true),
    mass: mass
  }
})

const getDataMatrix = async (data) => {
  noloading.value = true
  const viewproduct = d.items.find(x => x._id == viewScaner.value.id)
  viewproduct.marking_code = window.btoa(unescape(encodeURIComponent(data)))
  viewproduct.marking_code_decode = data
  viewScaner.value.view = false
  getZnak.value.view = true
  getZnak.value.loading = true

  const getZnakData = await axios.post('https://api.ultimatum.store/arm/znak/check', { marking: data })
  if (getZnakData.status == 'good') {
    viewproduct.marking_uuid = getZnakData.uuid
    getZnak.value.good = true
    getZnak.value.loading = false
    getZnak.value.comment = ''
  }
  if (getZnakData.status == 'error') {
    getZnak.value.good = false
    getZnak.value.loading = false
    getZnak.value.comment = getZnakData.comment
  }
  noloading.value = false
}

const getProductBarcode = async (barcode) => {
  try {
    const otvet = await axios.post('https://api.ultimatum.store/arm/shop/barcode', { barcode: barcode })
    if (otvet.status == 'error') {
      notSet('Штрихкод не распознан')
      return
    }
    if (otvet.product.activityspecifications) {
      let guids = null
      for (const two of otvet.product.specifications) {
        if (two._id == otvet.spec) { guids = `${otvet.product.guid}#${two.guid}` }
      }
      for (const one of d.items) {
        if (one.guid == guids) {
          one.quan++
          notSet('Товар добавлен')
          return
        }
      }
    } else {
      for (const one of d.items) {
        if (one.guid == `${otvet.product.guid}`) {
          one.quan++
          notSet('Товар добавлен')
          return
        }
      }
    }
    notSet('Товар не найден в заказе')
  } catch (e) {
    console.log(e)
  }
}

onMounted(() => {
  for (const one of d.items) {
    one.quan = 0
    one.sta = false
    if (one.productid.model?.marking) {
      one.marking = true
    }
  }
})
</script>

<style scoped>
/* Счетчик сборки */
.assembly-counter {
      position: fixed;
    top: 74px;
    right: 5px;
    z-index: 100;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 14px;
    background: var(--bg-primary);
    border: 1px solid var(--border-light);
    border-radius: var(--border-radius-xl);
    box-shadow: 0 2px 8px var(--shadow-color);
    font-weight: 500;
}

.counter-value {
 font-size: 18px;
    color: var(--accent-black);
    font-weight: 200;
}

.counter-separator {
  font-size: 16px;
  color: var(--text-tertiary);
}

.counter-total {
  font-size: 18px;
    color: var(--accent-black);
    font-weight: 200;
}


.scanner-wrapper {
     position: fixed;
    top: 61px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    overflow: hidden;
    width: 101%;
}


.products-list {
  display: grid;
  gap: 12px;
  margin-top: 80%;
  padding-bottom: 80px;
}

.product-item {
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 12px;
  padding: 16px;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  transition: all var(--transition-fast);
}

.product-item.completed {
  background: var(--green-light);
  border-color: var(--green);
}

.product-item:hover {
  background: var(--tile-hover-bg);
  border-color: var(--tile-hover-border);
}

/* Галочка завершения */
.completed-badge {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 24px;
  height: 24px;
  background: var(--green);
  border: 2px solid var(--bg-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 4px var(--shadow-color);
}

/* Фото товара */
.product-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: var(--border-radius-sm);
  background: var(--tile-icon-bg);
  padding: 4px;
}

/* Детали товара */
.product-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-name {
  font-size: 15px;
  font-weight: var(--font-weight-medium);
  color: var(--text-primary);
  margin: 0;
}

.product-sku {
    font-size: 13px;
    color: var(--text-primary);
    margin: 0;
    font-weight: 400;
}

.product-quantity {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* Поле ввода количества */
.quantity-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.input-label {
    font-size: 13px;
    color: var(--text-primary);
    margin: 0;
    font-weight: 400;  
}

.input-field {
  width: 70px;
  padding: 6px 8px;
  background: var(--bg-primary);
  border: 1px solid var(--border-medium);
  border-radius: var(--border-radius-sm);
  color: var(--text-primary);
  text-align: center;
      font-size: 15px;
    font-weight: 500;
}

.input-field:focus {
  outline: none;
  border-color: var(--accent-black);
}

/* Блок Честного знака */
.marking-block {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-top: 8px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius-sm);
}

.marking-status {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-label {
  font-size: 12px;
  color: var(--text-tertiary);
}

.status-value {
  font-size: 13px;
  color: var(--text-primary);
  word-break: break-all;
}

.status-value.not-scanned {
  color: var(--red);
  font-style: italic;
}

.marking-btn {
  padding: 8px 16px;
  background: var(--accent-black);
  color: var(--text-inverse);
  border: 1px solid var(--accent-black);
  border-radius: var(--border-radius-md);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.marking-btn:hover {
  background: var(--btn-accent-hover);
  border-color: var(--btn-accent-hover);
}

/* Модалка сканера */
.scanner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: var(--bg-primary);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.scanner-header {
  padding: 16px;
  border-bottom: 1px solid var(--border-light);
}

.close-btn {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid var(--border-medium);
  border-radius: var(--border-radius-md);
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.close-btn:hover {
  background: var(--bg-tertiary);
}

/* Модалка результата */
.result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: var(--overlay-light);
  backdrop-filter: blur(8px);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.result-content {
  width: 100%;
  max-width: 400px;
  background: var(--bg-primary);
  border: 1px solid var(--border-light);
  border-radius: var(--border-radius-lg);
  padding: 24px;
  box-shadow: 0 20px 40px var(--shadow-color);
}

.result-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  text-align: center;
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-light);
  border-top-color: var(--accent-black);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.success {
  color: var(--green);
  font-size: 18px;
  font-weight: 500;
}

.error {
  color: var(--red);
  font-size: 18px;
  font-weight: 500;
}

.result-comment {
  color: var(--text-secondary);
  font-size: 14px;
}

.result-btn {
  width: 100%;
  padding: 14px;
  background: var(--accent-black);
  color: var(--text-inverse);
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.result-btn:hover {
  background: var(--btn-accent-hover);
}

/* Кнопка завершения */
.complete-btn {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  max-width: 400px;
  padding: 16px;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--border-radius-md);
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all var(--transition-fast);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.3);
  z-index: 100;
}

.complete-btn:hover {
  background: var(--green-dark);
  transform: translateX(-50%) translateY(-2px);
  box-shadow: 0 6px 16px rgba(22, 163, 74, 0.4);
}

/* Темная тема */
html.dark .product-item.completed {
  background: var(--green-dark);
  border-color: var(--green);
}

html.dark .complete-btn {
  box-shadow: 0 4px 12px rgba(74, 222, 128, 0.2);
}

html.dark .scanner-modal {
  background: var(--bg-secondary);
}

.sborkaviewcount{
    display: grid;
    grid-template-columns: auto auto auto;
    gap: 10px;
    width: max-content;
    align-items: center;
    justify-items: center;
}

.nuzno{
font-size: 15px;
    font-weight: 500;
        margin-top: -5px;
}

.palka{
font-size: 15px;
    font-weight: 500;
        margin-top: -5px;
}
.goodsborka{
    position: fixed;
    bottom: 12px;
    left: 3%;
    margin-top: 20px;
    width: 94%;
}

</style>